import type { AppConfig } from '@dvms/shared-types';
import { validateConfig } from './validate';

let cachedConfig: AppConfig | null = null;

export function loadConfig(): AppConfig {
    if (cachedConfig) {
        return cachedConfig;
    }

    const raw = window.__RUNTIME_CONFIG__;
    if (!raw) {
        throw new Error('Runtime config not found. Ensure config.js is loaded before the application.');
    }

    const config = validateConfig(raw);

    // Merge build-time values
    config.version = String(import.meta.env.VITE_APP_VERSION);
    config.buildNumber = String(import.meta.env.VITE_BUILD_NUMBER);
    config.buildTime = String(import.meta.env.VITE_BUILD_TIME);
    config.commitSha = String(import.meta.env.VITE_COMMIT_SHA);

    cachedConfig = config;
    return config;
}

export function getConfig(): AppConfig {
    if (!cachedConfig) {
        throw new Error('Config not loaded. Call loadConfig() before accessing config.');
    }
    return cachedConfig;
}
